/* eslint-disable */
/* tslint:disable */

/** createOneSignalWhenLoggedIn
 * method: post
 * summary: Creating onesignal trace for the logged user
 */

import type {
  CreateWhenLoggedInInput,
  GeneralOkNotOkResultDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/notification/one-signal/register`
export const fullPath = `${process.env.NOTIFICATION_BASE_URL || 'http://notification.svc.cluster.local'}/notification/one-signal/register`

export type RequestBody = CreateWhenLoggedInInput

export type CreateOneSignalWhenLoggedInSuccess = GeneralOkNotOkResultDto
export type CreateOneSignalWhenLoggedInError = ApiResponseDto
